import { useCallback, useState } from 'react';

/**
 * Elementi per pagina ricordati nel browser, per pagina (`key`).
 *
 * Si ricorda solo una scelta fra `allowed`: un valore diverso (es. "mostra
 * tutti") vale per la visita ma non sostituisce la preferenza salvata.
 * Senza localStorage (navigazione privata, dati bloccati) si parte da
 * `fallback` e la scelta dura quanto la pagina.
 */
export function usePageSize(key: string, allowed: number[], fallback = allowed[0]) {
  const storageKey = `dtk_pagesize_${key}`;
  const [pageSize, setState] = useState<number>(() => {
    try {
      const saved = Number(localStorage.getItem(storageKey));
      return allowed.includes(saved) ? saved : fallback;
    } catch {
      return fallback;
    }
  });

  const setPageSize = useCallback((n: number) => {
    setState(n);
    if (!allowed.includes(n)) return;
    try {
      localStorage.setItem(storageKey, String(n));
    } catch {
      /* preferenza non salvata: resta per questa visita */
    }
  }, [storageKey, allowed]);

  return [pageSize, setPageSize] as const;
}
